function toDay(date: Date): Date {
    const d = new Date(date)
    d.setHours(0, 0, 0, 0)
    return d
}

function today(): Date {
    return toDay(new Date())
}

/** Returns true if prepayment_until is today or in the future */
export function isPrepaymentActive(prepaymentUntil: string | null | undefined): boolean {
    if (!prepaymentUntil) return false
    return toDay(new Date(prepaymentUntil)) >= today()
}

/** Returns true if prepayment_until is in the past (strictly before today) */
export function isPrepaymentExpired(prepaymentUntil: string | null | undefined): boolean {
    if (!prepaymentUntil) return false
    return toDay(new Date(prepaymentUntil)) < today()
}

/**
 * Returns true if prepayment_until is between today and one month from now (inclusive).
 * Used to decide whether to show the expiry warning.
 */
export function isPrepaymentExpiringWithinMonth(prepaymentUntil: string | null | undefined): boolean {
    if (!prepaymentUntil) return false
    const until = toDay(new Date(prepaymentUntil))
    const now = today()
    const oneMonthFromNow = toDay(new Date())
    oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1)
    return now <= until && until <= oneMonthFromNow
}

/** Returns true if prepayment_until is exactly today */
export function isPrepaymentExpiringToday(prepaymentUntil: string | null | undefined): boolean {
    if (!prepaymentUntil) return false
    return toDay(new Date(prepaymentUntil)).getTime() === today().getTime()
}
